export const IframePage = () => {

    return (
        <div>
            <iframe allow="fullscreen; xr-spatial-tracking" width={1300} height={700} src={'http://localhost:3000/viewer/4'}/>
        </div>
    )
}